// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat-typing';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.367 14.1H8.433L3.9 17.5v-3.4H1.633A1.133 1.133 0 0 1 .5 12.967V1.633A1.133 1.133 0 0 1 1.633.5h14.734A1.134 1.134 0 0 1 17.5 1.633v11.334a1.134 1.134 0 0 1-1.133 1.133z' />
    <path d='M9 7.583a.283.283 0 1 1 0-.566m0 .566a.283.283 0 0 0 0-.566m-3.4.566a.283.283 0 0 1 0-.566m0 .566a.283.283 0 0 0 0-.566m6.8.566a.283.283 0 0 1 0-.566m0 .566a.283.283 0 1 0 0-.566' />
  </g>
);

export const viewBox = '0 0 18 18';
